import gatewaysService from "@/services/gateway.service";

export const gateways = {
  namespaced: true,
  state: {
    gateways: []
  },
  getters: {},
  actions: {
    async getGateways({ commit }) {
      try {
        const gateways = await gatewaysService.getGateways();

        commit("setGateways", gateways);
      } catch (error) {
        Vue.noty.error("Error getting gateways");
      }
    }
  },
  mutations: {
    setGateways(vuexState, payload) {
      vuexState.gateways = payload;
    }
  }
};
